import type { Apparence } from '@rh/shared';

/**
 * Style d'affichage (migration 014). La valeur de référence est celle du
 * compte ; le téléphone garde la dernière appliquée, pour que l'écran de
 * connexion et le démarrage s'affichent tout de suite dans le bon style.
 */
const CLE = 'rh.apparence';

export function apparenceMemorisee(): Apparence {
  try {
    return globalThis.localStorage?.getItem(CLE) === 'sombre' ? 'sombre' : 'clair';
  } catch {
    return 'clair';
  }
}

export function appliquerApparence(apparence: Apparence): void {
  document.documentElement.dataset.theme = apparence;
  try {
    globalThis.localStorage?.setItem(CLE, apparence);
  } catch {
    /* stockage refusé : le style vaut pour cette page seulement */
  }
}
